<template>
  <div>
    <div :class="contClass">
      <router-view :key="$route.fullPath" />
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";

export default {
  computed: {
    ...mapState([]),

    contClass() {
      return ["cont", this.isAccountRoute ? "full" : ""];
    },
    isAccountRoute() {
      return /^\/account(\/|$)/.test(this.$route.path);
    },
  },
  mounted() {},
};
</script>
